import { useState, useEffect, useRef } from "react"

function MessagePanel({ mensajes, userId, contactName, onEnviar, onBack }) {
  const [texto, setTexto] = useState("")
  const [enviando, setEnviando] = useState(false)
  const bottomRef = useRef(null)
  const inputRef = useRef(null)

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" })
  }, [mensajes])

  useEffect(() => {
    inputRef.current?.focus()
  }, [contactName])

  const handleEnviar = () => {
    if (!texto.trim() || enviando) return
    setEnviando(true)
    onEnviar(texto.trim())
    setTexto("")
    setTimeout(() => setEnviando(false), 400)
  }

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault()
      handleEnviar()
    }
  }

  const formatTime = (ts) =>
    new Date(ts).toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit" })

  return (
    <div className="message-panel">
      <div className="msg-header">
        <button className="back-btn" onClick={onBack} aria-label="Volver">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <div className="msg-header-avatar">{contactName?.[0]?.toUpperCase()}</div>
        <div className="msg-header-name">{contactName}</div>
      </div>

      <div className="messages">
        {mensajes.length === 0 && (
          <div className="messages-empty">
            <p>Empieza la conversación con <strong>{contactName}</strong></p>
          </div>
        )}
        {mensajes.map((msg, i) => {
          const esMio = msg.from === userId
          return (
            <div key={i} className={`message ${esMio ? "sent" : "received"}`}>
              <p>{msg.texto}</p>
              <span className="msg-time">{formatTime(msg.timestamp)}</span>
            </div>
          )
        })}
        <div ref={bottomRef} />
      </div>

      <div className="input-area">
        <input
          ref={inputRef}
          placeholder={`Mensaje para ${contactName}…`}
          value={enviando ? "Enviando..." : texto}
          onChange={e => setTexto(e.target.value)}
          onKeyDown={handleKeyDown}
          disabled={enviando}
        />
        <button
          className={`send-btn ${enviando ? "sending" : ""}`}
          onClick={handleEnviar}
          disabled={!texto.trim() || enviando}
          aria-label="Enviar mensaje"
        >
          {enviando
            ? <span className="btn-loading"><span /><span /><span /></span>
            : (
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="22" y1="2" x2="11" y2="13" />
                <polygon points="22 2 15 22 11 13 2 9 22 2" fill="currentColor" stroke="none" />
              </svg>
            )
          }
        </button>
      </div>
    </div>
  )
}

export default MessagePanel
